export const faqs = [
  {
    q: "网曝吃瓜是一个什么样的网站？",
    a: "网曝吃瓜是一个聚焦全网热门话题的内容聚合站，把热搜榜单、话题流和讨论现场放在同一个页面里。你不用在多个平台之间来回切换，打开首页就能看到当下热度最高的话题脉络。",
  },
  {
    q: "话题的热度值是怎么来的？",
    a: "热度值综合了话题的讨论量、阅读量、互动增速和时间衰减四个维度，是一个相对指标而不是绝对人数。热度会随着讨论降温而下降，所以榜单一直处于实时变化中。",
  },
  {
    q: "首页的围观现场多久更新一次？",
    a: "围观现场会跟随话题讨论的活跃度滚动更新，热度越高的话题更新越频繁。页面上显示的“更新时间”就是你看到这屏内容的最后刷新时间。",
  },
  {
    q: "我可以参与话题讨论吗？",
    a: "可以。在话题卡片上可以看到当前的讨论热度与评论规模，我们也欢迎你把有意思的观点整理成线索发给我们，经整理后的内容会出现在围观现场中。",
  },
  {
    q: "网站上的内容是否经过核实？",
    a: "站内内容以“整理公开讨论”为主，我们会标注信息来源与时间。对于尚未有明确结论的话题，我们会在描述中说明争议点，不做单方面判断，也建议大家理性看待。",
  },
  {
    q: "如何联系我们提供话题线索？",
    a: "可以通过页面底部的联系邮箱与我们取得联系，也可以在订阅表单留下你的联系方式。线索越具体、时间越明确，被收录的效率就越高。",
  },
];